import React, { PropsWithChildren } from 'react';
import ConfirmModal from 'Components/ConfirmModal';
import { BaseModalProps } from 'Components/UIComponents/interfaces/UIModal';
import UIButton from 'Components/UIComponents/UIButton';

interface DeleteModalProps extends BaseModalProps {
  onClose: () => void;
  onConfirm: () => void;
  deleteTitle?: string;
  cancelTitle?: string;
  className?: string;
}

const DeleteModal = ({
  onClose,
  onConfirm,
  children,
  deleteTitle = 'Yes, Delete',
  cancelTitle,
  ...modalProps
}: PropsWithChildren<DeleteModalProps>) => {
  return (
    <ConfirmModal
      onClose={onClose}
      confirmComponent={() => (
        <UIButton
          priority="red"
          handleClick={onConfirm}
          className="confirmModal__button--delete"
          title={deleteTitle}
        />
      )}
      cancelComponent={() => (
        <div className="documents__deleteModal--cancel" onClick={onClose}>
          {cancelTitle}
        </div>
      )}
      isCancellable={!!cancelTitle}
      isOverlayTransparent={true}
      {...modalProps}
    >
      {children}
    </ConfirmModal>
  );
};

export default DeleteModal;
